/* eslint-disable no-restricted-globals */
import { AdminNavigation, Footer, Navigation } from 'components/common';
import * as ROUTES from 'constants/routes';
import { createBrowserHistory } from 'history';
import React from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import * as view from 'views';
import AdminRoute from './AdminRoute';
import ClientRoute from './ClientRoute';
import PublicRoute from './PublicRoute';

export const history = createBrowserHistory();

const AppRouter = () => (
  <Router history={history}>
    <>
      <Navigation />
      <AdminNavigation />
      <Switch>
        <Route component={view.Home} exact path={ROUTES.HOME} />
        <Route component={view.Shop} exact path={ROUTES.SHOP} />
        <PublicRoute component={view.SignUp} path={ROUTES.SIGNUP} />
        <PublicRoute component={view.SignIn} exact path={ROUTES.SIGNIN} />
        <PublicRoute
          component={view.ForgotPassword}
          path={ROUTES.FORGOT_PASSWORD}
        />
        <Route component={view.ViewProduct} path={ROUTES.VIEW_PRODUCT} />
        <ClientRoute component={view.UserAccount} exact path={ROUTES.ACCOUNT} />
        <ClientRoute
          component={view.EditAccount}
          exact
          path={ROUTES.ACCOUNT_EDIT}
        />
        <PublicRoute component={view.Messages} exact path={ROUTES.MESSAGES} />
        <PublicRoute
          component={view.ViewMessage}
          exact
          path={ROUTES.VIEW_MESSAGE}
        />
        <ClientRoute component={view.AddProduct} path={ROUTES.ADD_PRODUCT} />
        <ClientRoute
          component={view.EditProduct}
          path={`${ROUTES.EDIT_PRODUCT}/:id`}
        />
        <ClientRoute component={view.Pricing} path={`${ROUTES.PRICING}`} />
        <AdminRoute
          component={view.Dashboard}
          exact
          path={ROUTES.ADMIN_DASHBOARD}
        />
        <AdminRoute component={view.Products} path={ROUTES.ADMIN_PRODUCTS} />
        <AdminRoute component={view.Users} path={ROUTES.ADMIN_USERS} />
        <AdminRoute component={view.Companies} path={ROUTES.ADMIN_COMPANIES} />
        <AdminRoute component={view.Images} path={ROUTES.ADMIN_IMAGES} />
        <AdminRoute component={view.Brands} path={ROUTES.ADMIN_BRANDS} />
        <AdminRoute component={view.Ads} path={ROUTES.ADMIN_ADS} />
        <AdminRoute component={view.Plans} path={ROUTES.ADMIN_PLANS} />
        <AdminRoute component={view.Payments} path={ROUTES.ADMIN_PAYMENTS} />
        <AdminRoute
          component={view.ProductsAdminAdd}
          path={ROUTES.ADMIN_PRODUCTS_ADD}
        />
        <AdminRoute
          component={view.ProductsAdminEdit}
          path={`${ROUTES.ADMIN_PRODUCTS_EDIT}/:id`}
        />
        <PublicRoute component={view.PageNotFound} />
      </Switch>
      <Footer />
    </>
  </Router>
);

export default AppRouter;
